import { useState } from 'react';
import { HexColorPicker, HexColorInput } from "react-colorful";

function ColourSelector(props) {
    const [pickerStyle, setPickerStyle] = useState({ display: "none" });
    const [buttonColour, setButtonColour] = useState(props.colour);

    function openClose() {
        if (pickerStyle.display === "none") {
            setPickerStyle({ display: "block" });
        }
        else {
            setPickerStyle({ display: "none" });
        }
    }

    function handleBlur() {
        setPickerStyle({ display: "none" });
    }

    function handleChange(color) {
        props.setColour(color);
        setButtonColour(color);
    }

    return (
        <div className="uiElement">
            <h3>{props.title}</h3>
            <button style={{ background: buttonColour }} className="colourButton" onBlur={handleBlur} onClick={() => openClose()} />
            <div className="pickerContainer" style={pickerStyle}>
                <HexColorPicker color={props.colour} onChange={color => handleChange(color)} />
            </div>
            <div className="hexContainer">
                <HexColorInput style={{ width: "50%" }} color={buttonColour} onChange={color => handleChange(color)} />
            </div>
            {/* <input type="color" defaultValue={props.colour} onblur={e => props.setColour(e.target.value)} /> */}
        </div>
    );
}

export default ColourSelector;